import React from 'react';
import { motion } from 'framer-motion';

import '@css/main.css';

import { Header } from '@components/nav/header';
import { Footer } from '@components/nav/footer';

const mainVars = {
  open: {
    opacity: 1,
    transition: {
      duration: 0.5,
      when: 'beforeChildren',
    },
  },
  closed: {
    opacity: 0,
    transition: {
      duration: 0.5,
      when: 'afterChildren',
    },
  },
};

const Layout = ({ children, altLogo, settings }) => {
  const { bgColor } = settings || {};
  return (
    <>
      <Header altLogo={altLogo} settings={settings} />
      <motion.main
        variants={mainVars}
        initial='closed'
        animate='open'
        exit='closed'
        style={bgColor && { backgroundColor: bgColor.hex }}
        className={`w-full absolute top-0 left-0`}>
        {children}
        <Footer settings={settings} />
      </motion.main>
    </>
  );
};

export default Layout;
